module.exports = __webpack_public_path__ + "146b53b7b7008368741cd8c4044c7e9d.svg";